// import { computeHeadingLevel } from '@testing-library/react';
import React, {Component} from "react";
import axios from "axios";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {getCountryJson} from "../../actions/actions";
import TabsContainer from "../ParseSections/TabsContainer";
import "./AllCountries.css";
import en from "../langs/en";
import ar from "../langs/ar";
import Translate from "react-translate-component";
import counterpart from "counterpart";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner, faCircleNotch} from "@fortawesome/free-solid-svg-icons";
counterpart.registerTranslations("en", en);
counterpart.registerTranslations("ar", ar);
let obj = {};
let objJson = {};
let selectedCountry = "";
// In the future when the URLs of countries names and countries data be ready DON't forget to change the same URLs in "JsonEditor" component

class AllCountries extends Component {
  state = {
    show: false,
    countriId: 1,
    countryDataLoader: true,
    countriesNameLoader: true,
    AllCountries: [],
    json: {new: "test"},
    tabsNames: [],
  };
  componentDidMount() {
    this.getAllCountries();
  }
  // Get all countries and render it in the page
  getAllCountries = () => {
    let json = {};
    // const countriesURL =
    //   "https://run.mocky.io/v3/595f8163-598b-4bcf-80d7-cbf1abb0f038";
    const countriesURL =
      "https://follow.leafwaysco.com/tradegate/apis/country_all.php";
    axios.post(countriesURL, json).then((res) => {
      this.setState({
        countriesNameLoader: false,
        AllCountries: res.data,
      });
    });
  };
  // when click on any country it will show country's json as a HTML elements
  // (id) ======> Country id
  showCountryJSON = (id, name, e) => {
    console.log(id);
    // add active class from counties
    let countriesElments = document.querySelectorAll(".country");
    for (let i = 0; i < countriesElments.length; i++) {
      countriesElments[i].classList.remove("active");
    }
    // add active class
    e.target.classList.add("active");
    // to Re-render active tabs every time you click on an country
    selectedCountry = `${name}`;
    this.setState({
      show: false,
      countryDataLoader: true,
      countriId: id,
    });
    // const URL = "https://run.mocky.io/v3/8af3b885-d01f-4c74-bfb2-3c20fdbf3ba1";
    const URL = `https://follow.leafwaysco.com/tradegate/apis/country_get.php?country_id=${id}`;
    axios.get(URL).then((res) => {
      obj = res.data;
      // Parse country's json to string
      const objString = JSON.stringify(obj);
      // Show country's json and Edit btn
      this.setState({
        countryJSON: objString,
        countryDataLoader: false,
      });
      objJson = JSON.parse(this.state.countryJSON);
    });
    setTimeout(() => {
      this.setState({
        show: true,
      });
    }, 100);
  };
  // when click on edit json btn it will take country's json and put it into JSON editor tool
  // (e) ======> Country's json
  editCountryJSON = (id, e, edit, name) => {
    console.log(this.props.getCountryJson(id, e, edit, name));
  };
  render() {
    return (
      <div className="container">
        <div className="allCountries-container">
          <Translate content="AllCountries.title" component="h2" />
          <div className="allCountries">
            {this.state.countriesNameLoader ? (
              <div className="text-center">
                <FontAwesomeIcon icon={faSpinner} spin size="4x" />
                {/* <FontAwesomeIcon icon={faCircleNotch} spin size="4x" /> */}
              </div>
            ) : (
              this.state.AllCountries.map((country) => (
                <p
                  id={country.id}
                  className="country"
                  key={country.id}
                  onClick={(e) =>
                    this.showCountryJSON(country.id, country.name, e)
                  }
                >
                  {country.name}
                </p>
              ))
            )}
          </div>
          {this.state.show ? (
            this.state.countryDataLoader ? (
              <div className="text-center">
                <FontAwesomeIcon icon={faSpinner} spin size="4x" />
                {/* <FontAwesomeIcon icon={faCircleNotch} spin size="4x" /> */}
              </div>
            ) : (
              <div className="countryTabs">
                <TabsContainer countryJson={obj} />
                <Link
                  to={"/editCountry/" + selectedCountry}
                  className="json-edit-btn"
                  onClick={(e) =>
                    this.editCountryJSON(
                      this.state.countriId,
                      objJson,
                      selectedCountry
                    )
                  }
                >
                  Edit JSON
                </Link>
              </div>
            )
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

export default connect(null, {getCountryJson})(AllCountries);
